<template>
  <div v-if="isVisible">
    <div
      class="property-indicator"
      :class="{
        'property-indicator--alt-pos': useAlternateIndicatorPosition,
        'property-indicator--rtl': lang.rtl
      }"
    >
      <div v-for="(marker, i) in markers" :key="`marker:${i}`">
        <AvailabilityMarker :status="marker.status" :x="lang.rtl ? 155 : 0" :y="5 + (56 * i)"></AvailabilityMarker>
        <div :dir="lang.rtl ? 'rtl' : 'ltr'">{{ counts[marker.status] || 0 }} - {{ marker.label }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import AvailabilityMarker from './AvailabilityMarker.vue';
import { camelCase } from 'lodash';

export default {
  components: {
    AvailabilityMarker
  },

  computed: {
    lang() {
      return this.$store.getters.language
    },

    markers() {
      return this.$store.state.newConfig.rightSidebar.propertyGuide.items.map((marker) => {
        const isStringMarker = typeof marker === 'string';
        const status = isStringMarker ? marker : marker.en;
        const markerConfig = this.$store.state.newConfig.markers[camelCase(status)];
        const configLabel = markerConfig && markerConfig.label;

        return {
          status,
          label: (
            (!isStringMarker && (marker[this.lang.code] || marker.en)) ||
            (configLabel && (configLabel[this.lang.code] || configLabel.en)) ||
            status
          )
        }
      })
    },

    counts() {
      return {
        Available: this.countAvailable,
        'On Hold': this.countOnHold,
        Sold: this.countSold,
        'Coming Soon': this.countComingSoon,
        'Builder Lots': this.countBuilderLots
      }
    },

    countAvailable () {
      return this.subsection.properties.filter(property => property.status === 'Available').length
    },

    countOnHold () {
      return this.subsection.properties.filter(property => property.status === 'On Hold').length
    },

    countBlocked () {
      return this.subsection.properties.filter(property => (property.status === 'Management Blocked' || property.status === 'Blocked')).length
    },

    countSold () {
      return this.subsection.properties.filter(property => property.status === 'Sold').length
    },

    countComingSoon () {
      return this.subsection.properties.filter(property => property.status === 'Coming Soon').length
    },

    countBuilderLots () {
      return this.subsection.properties.filter(property => property.status === 'Builder Lots').length
    },

    isVisible () {
      const isActive = this.$store.state.newConfig.general.showProductCountWidget

      return (
        isActive &&
        this.subsection &&
        this.subsectionChildType === 'property'
      )
    },

    subsection () {
      return this.$store.getters['property/activeSubsection']
    },

    subsectionChildType () {
      if (!this.subsection) return null
      if (this.subsection.subsections && this.subsection.subsections.length) {
        return 'subsection'
      } else {
        return 'property'
      }
    },

    useAlternateIndicatorPosition () {
      return this.subsection._id === '60519bb09106ce12d5a63887'
    }
  }
}
</script>
<style lang="scss">
.property-indicator {
  pointer-events: none;
  position: absolute;
  bottom: 17rem;
  left: 2rem;
  background-color: var(--subbottombar-bg-color);
  padding: 1rem;
  font-size: 1.4rem;
  width: 16rem;
  z-index: 100;

  &--alt-pos {
    bottom: auto;
    top: 2rem;
  }

  .availability-marker {
    transform: scale(0.7);
  }

  > div {
    line-height: 2;
    font-weight: var(--font-weight-secondary);
    margin-left: 2.5rem;
  }

  &--rtl > div {
    margin-right: 2.5rem;
  }
}
</style>
